// src/components/PageTransition.jsx
import React, { useEffect, useRef, useState } from "react";
import "./PageTransition.css";

const PageTransition = ({ children, location }) => {
  const transitionRoutes = new Set(["/", "/categories", "/archive", "/about"]);

  const pageOrder = {
    "/": 0,
    "/categories": 1,
    "/archive": 2,
    "/about": 3,
  };

  const getCurrentPageOrder = (pathname) =>
    pageOrder[pathname] !== undefined ? pageOrder[pathname] : 999;

  const [transitionState, setTransitionState] = useState({
    current: { children, location },
    previous: null,
    direction: "forward",
    animate: false,
  });

  const prevLocationRef = useRef(location);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const previousLocation = prevLocationRef.current;
    const fromPath = previousLocation.pathname;
    const toPath = location.pathname;
    prevLocationRef.current = location;

    const shouldAnimate =
      transitionRoutes.has(fromPath) &&
      transitionRoutes.has(toPath) &&
      fromPath !== toPath;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!shouldAnimate) {
      setTransitionState({
        current: { children, location },
        previous: null,
        direction: "forward",
        animate: false,
      });
      return undefined;
    }

    const direction =
      getCurrentPageOrder(toPath) >= getCurrentPageOrder(fromPath)
        ? "forward"
        : "back";

    setTransitionState((prev) => ({
      current: { children, location },
      previous: prev.current,
      direction,
      animate: true,
    }));

    timeoutRef.current = setTimeout(() => {
      setTransitionState((prev) => ({
        ...prev,
        previous: null,
        animate: false,
      }));
    }, 360);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [children, location]);

  return (
    <div className="page-transition-wrapper">
      {transitionState.previous && (
        <div
          className={`page-wrapper previous slide-${transitionState.direction}-exit`}
        >
          {transitionState.previous.children}
        </div>
      )}
      <div
        className={`page-wrapper page-current${
          transitionState.animate
            ? ` slide-${transitionState.direction}-enter`
            : ""
        }`}
      >
        {transitionState.current.children}
      </div>
    </div>
  );
};

export default PageTransition;
